var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"input-area",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }